module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"Something went wrong or this page does not exist. <br> After 5 seconds you will be redirected to the main page."},"ru":{"message":"Что-то пошло не так или эта страница не существует.<br> Через 5 секунд вы будете переадресованы на главную страницу"}}')
  delete Component.options._Ctor
}
